import { useEffect, useState } from "react";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Row, Col, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAllPositions } from "../../redux/actions/mainAction";
import noitem from "../../images/noitem.gif";

const { confirm } = Modal;

const PositionsTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    getPositions(page);
  }, [GlobalResponse.triggeranyevent, page]);

  const getPositions = async (page) => {
    try {
      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-positions/?page=${page}`,
        {
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      dispatch(setAllPositions(result.positions));
      setTotalPages(result.totalPages);
    } catch (error) {}
  };

  const showDeleteConfirm = (positiontName, _id, employeeCount) => {
    if (employeeCount < 1) {
      confirm({
        centered: "centered",
        title: positiontName,
        icon: <ExclamationCircleFilled />,
        content: "Vəzifəni silmək istədiyinizdən əminsiniz?",
        okText: "Sil",
        okType: "danger",
        cancelText: "İmtina Et",
        onOk() {
          deletePosition(_id);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } else {
      confirm({
        centered: "centered",
        title: positiontName + " silinə bilməz!",
        icon: <ExclamationCircleFilled />,
        content:
          "Bu vəzifəni silmək üçün əvvəlcə bu vəzifədə çalışan əməkdaşları silmək lazımdır!",
        okText: "Oldu",
        okType: "danger",
        cancelText: "Əməkdaşlar",
        onOk() {},
        onCancel() {
          navigate("/employees");
        },
      });
    }
  };

  const deletePosition = async (_id) => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/position/${_id}`,
      {
        method: "delete",
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    console.log(result);
    if (result) {
      getPositions();
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      {MainResponse.allPositions.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Vəzifənin Adı</th>
              <th>Şirkət</th>
              <th>Şöbənin Adı</th>
              <th>Əməkdaş Sayı</th>
              <th>Əməliyyat</th>
            </tr>
          </thead>
          {MainResponse.allPositions.length > 0 ? (
            MainResponse.allPositions.map((position, index) => (
              <tbody key={position._id}>
                <tr>
                  <td>{position._id}</td>
                  <td>{position.positionName}</td>
                  <td>{position.companyName}</td>
                  <td>{position.departmentName}</td>
                  <td>{position.employeeCount}</td>

                  <td>
                    <Link
                      state={{ id: position._id }}
                      className="btn"
                      to="/positionedit"
                    >
                      {<BiEdit />}
                    </Link>

                    <Link
                      onClick={() =>
                        showDeleteConfirm(
                          position.positionName,
                          position._id,
                          position.employeeCount
                        )
                      }
                      className="btn-del"
                    >
                      {<AiFillDelete />}
                    </Link>
                  </td>
                </tr>
              </tbody>
            ))
          ) : (
            <h1>Netice yoxdur</h1>
          )}
        </table>
      ) : (
        <div className="no-item">
          <Row>
            <Col span={24}>
              <div className="no-item">
                <img style={{ width: "342px" }} src={noitem} alt="noitem" />
              </div>
            </Col>
          </Row>
        </div>
      )}

      {totalPages > 0 && (
        <div className="pagination">
          <button
            disabled={page === 1}
            onClick={() => handlePageChange(page - 1)}
          >
            Əvvəlki
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              className={page === index + 1 ? "active" : ""}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            disabled={page === totalPages}
            onClick={() => handlePageChange(page + 1)}
          >
            Növbəti
          </button>
        </div>
      )}
    </>
  );
};

export default PositionsTable;
